import { Text } from '@podiumhq/design-system';

import { inputErrorMessageStyles } from 'styles';

export const TrialFieldError = ({ children, displayError, ...props }) =>
  displayError ? (
    <Text {...inputErrorMessageStyles} {...props}>
      {children}
    </Text>
  ) : null;

export default TrialFieldError;
